import type { ReactNode } from 'react';

import type { ContentfulNavQuickLinkFragment } from '@/graphql/contentful/api';

import { useHandleQuickLink } from '../NavQuickLinkItem/helpers';

import { ReactComponent as EasyContactIcon } from '@/assets/icons/concierge.svg';
import { ReactComponent as GiftOfferedIcon } from '@/assets/icons/gift.svg';
import { ReactComponent as FreeReturnIcon } from '@/assets/icons/return.svg';
import { ReactComponent as FreeShippingIcon } from '@/assets/icons/shipping.svg';

import * as S from './NavQuickLinkPillItem.styles';

const ICONS_MAPPING: Record<string, ReactNode> = {
  shipping: <FreeShippingIcon />,
  gift: <GiftOfferedIcon />,
  'free-return': <FreeReturnIcon />,
  'easy-contact': <EasyContactIcon />,
};

export interface NavQuickLinkProps extends ContentfulNavQuickLinkFragment {
  className?: string;
  isCurrentLink?: boolean;
}

export const NavQuickLinkPillItem = ({
  className,
  icon,
  isCurrentLink = false,
  media,
  url,
  urlTarget,
  urlText,
  urlTrigger,
}: NavQuickLinkProps) => {
  const hasMatchingIcon = icon && icon in ICONS_MAPPING;

  const { handleQuickLink } = useHandleQuickLink(
    url ?? '/',
    urlTarget ?? '_self',
    urlTrigger,
  );
  return (
    <S.Wrapper
      key={url}
      $isCurrentLink={isCurrentLink}
      className={className}
      data-test-id='NavQuickLinkPillItemWrapper'
      onClick={handleQuickLink}
    >
      {icon && hasMatchingIcon && ICONS_MAPPING[icon]}
      {media && (
        <S.NavQuickImgBox data-test-id='NavQuickLinkPillItemNavQuickImgBox'>
          <S.NavQuickImg
            alt={media.title ?? ''}
            aria-hidden
            className={className}
            data-test-id='NavQuickLinkPillItemNavQuickImg'
            data-testid='servicesImage'
            fill
            height={0}
            loaderHeight={350}
            loading='eager'
            sizes='50vw'
            src={media.url ?? ''}
            width={0}
          />
        </S.NavQuickImgBox>
      )}
      <S.Label data-test-id='NavQuickLinkPillItemLabel'>{urlText}</S.Label>
    </S.Wrapper>
  );
};
